module.exports = __webpack_public_path__ + "static/media/card1_1.18c65dc5.png";